import React from 'react';
import { SortableElement, SortableElementProps } from 'react-sortable-hoc';
import { FlexBox, Typography, Box, SvgIcon } from '@kis-technologies/kis-ui';

interface MediaRowProps {
  label: string;
  selected: boolean;
  cursor?: string;
  onClick: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

export const MediaRow: React.FC<MediaRowProps> = (props: MediaRowProps) => {
  const { selected, label, cursor, onClick, onEditClick, onDeleteClick } = props;
  const rowColor = selected ? '#EFEFEF' : '#FFFFFF';
  const flagColor = selected ? '#f46d2e' : '#FFFFFF';
  const accentColor = selected ? '#f46d2e' : '#2A2A2A';

  return (
    <FlexBox
      height={50}
      align="center"
      justify="between"
      direction="row"
      onClick={onClick}
      sx={{ backgroundColor: rowColor, cursor }}
    >
      <FlexBox height={50} align="center" sx={{ borderLeft: `7px solid ${flagColor}` }}>
        <Box fullHeight width={8} margin="0 3 0 0" sx={{ backgroundColor: flagColor }} />
        <Typography fontSize={18}>{label}</Typography>
      </FlexBox>
      <FlexBox margin="0 4" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {onDeleteClick && (
          <FlexBox sx={{ cursor: 'pointer' }} align="center" margin="0 2" onClick={onDeleteClick}>
            <SvgIcon name="exit_circle" color={accentColor} size={24} />
          </FlexBox>
        )}
        {onEditClick && (
          <FlexBox sx={{ cursor: 'pointer' }} align="center" margin="0 2" onClick={onEditClick}>
            <SvgIcon name="edit_circle" color={accentColor} size={24} />
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SortableRow: React.ComponentClass<SortableElementProps & MediaRowProps, any> = SortableElement(
  (props: MediaRowProps) => MediaRow(props)
);
